var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 15,
    viewBox: "0 0 13 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.95546 2.00907H3.82153C3.89519 2.00907 3.95546 1.9488 3.95546 1.87514V2.00907H9.04475V1.87514C9.04475 1.9488 9.10502 2.00907 9.17868 2.00907H9.04475V3.21443H10.2501V1.87514C10.2501 1.28418 9.76964 0.803711 9.17868 0.803711H3.82153C3.23057 0.803711 2.7501 1.28418 2.7501 1.87514V3.21443H3.95546V2.00907ZM12.393 3.21443H0.607248C0.310931 3.21443 0.0715332 3.45382 0.0715332 3.75014V4.28585C0.0715332 4.35951 0.131801 4.41978 0.205462 4.41978H1.21662L1.63013 13.1754C1.65691 13.7462 2.12901 14.1966 2.69988 14.1966H10.3003C10.8729 14.1966 11.3433 13.7479 11.3701 13.1754L11.7836 4.41978H12.7947C12.8684 4.41978 12.9287 4.35951 12.9287 4.28585V3.75014C12.9287 3.45382 12.6893 3.21443 12.393 3.21443ZM10.1714 12.9912H2.82879L2.42365 4.41978H10.5766L10.1714 12.9912Z",
    fill: "#F25555"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete-icon.4e4cfdf75311bf9105a44e75274e009e.svg";
export { ForwardRef as ReactComponent };